<res-base-modal modalTitle="Find in Tree" modalAutomationId="target-picker" [modalClass]="modalClass"
    [modalHelpIndex]="helpIdx" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [resizeHorizontal]="true" [resizeVertical]="true" [resizeVerticalMin]="500" [resizeHorizontalMin]="500"
    [maximizable]="true">
    <div class="filter-bar">
        <res-filter [filterInputAutoId]="modalAutomationId" [clearButtonDataAutoId]="modalAutomationId" [maxChars]=32
            [placeholder]='"Filter (2+ chars.) ..."' [callback]="filterData.bind(this)"
            [autofocusInput]="inputAutoFocused">
        </res-filter>
        <res-custom-checkbox [automationId]="modalAutomationId + '-hide-empty-targets'" content="Hide Empty Views"
            [(ngModel)]="hideEmptyViews" (ngModelChange)="hideEmptyViewsChanged()" [labelPaddingLeft]="10"
            [labelPaddingRight]="10">
        </res-custom-checkbox>
    </div>
    <div class="tree-container">
        <res-generic-tree
            customClasses="generic-tree-picker-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top"
            [automationId]="modalAutomationId" [allowDeselection]="true"
            [hasFilterOn]="filterValue !== null && filterValue !== ''"
            [selectedNodeChangedCallback]="selectedNodeChangedCallback"
            [doubleClickAction]="doubleClickAction.bind(this)" [checkPermissions]="true">
        </res-generic-tree>
    </div>
</res-base-modal>